import locale from 'modules/webchat/presentation/locale';

/**
 * Só os textos entram pelo agregador: o WebchatGlobalContainer continua
 * montado em App.js, acima das rotas.
 */
const webchatModule = {
  locale,
};

export default webchatModule;
